/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewConfidenceData
 */
export interface CRSFSecReviewConfidenceData {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewConfidenceData
     */
    score: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewConfidenceData
     */
    version: string;
}

/**
 * Check if a given object implements the CRSFSecReviewConfidenceData interface.
 */
export function instanceOfCRSFSecReviewConfidenceData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "score" in value;
    isInstance = isInstance && "version" in value;

    return isInstance;
}

export function CRSFSecReviewConfidenceDataFromJSON(json: any): CRSFSecReviewConfidenceData {
    return CRSFSecReviewConfidenceDataFromJSONTyped(json, false);
}

export function CRSFSecReviewConfidenceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewConfidenceData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'score': json['score'],
        'version': json['version'],
    };
}

export function CRSFSecReviewConfidenceDataToJSON(value?: CRSFSecReviewConfidenceData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'score': value.score,
        'version': value.version,
    };
}

